/** Sectors served, with the waste profile typical to each. */

export const industries = [
  {
    id: 'it-ites',
    icon: 'MonitorSmartphone',
    name: 'IT & ITES',
    description:
      'Laptop refresh cycles, workstation retirement and campus-wide asset disposal with certified data destruction.',
    streams: ['Laptops & desktops', 'Monitors', 'Networking gear'],
  },
  {
    id: 'bfsi',
    icon: 'Landmark',
    name: 'Banking & Financial Services',
    description:
      'Branch-level collection across geographies with RBI-grade data handling and witnessed destruction options.',
    streams: ['ATM assemblies', 'Servers & storage', 'Passbook printers'],
  },
  {
    id: 'manufacturing',
    icon: 'Factory',
    name: 'Manufacturing',
    description:
      'Plant floor electronics, control panels and machinery decommissioning handled with on-site dismantling crews.',
    streams: ['PLC & control panels', 'Motors & drives', 'Cabling'],
  },
  {
    id: 'healthcare',
    icon: 'HeartPulse',
    name: 'Healthcare & Diagnostics',
    description:
      'Decommissioning of imaging and diagnostic equipment with patient-data sanitisation before any asset moves.',
    streams: ['Imaging systems', 'Lab analysers', 'Patient monitors'],
  },
  {
    id: 'telecom',
    icon: 'RadioTower',
    name: 'Telecom',
    description:
      'Tower and exchange sweeps for legacy BTS equipment, RRUs and large battery banks under a single work order.',
    streams: ['BTS & RRU units', 'Battery banks', 'Fibre equipment'],
  },
  {
    id: 'education',
    icon: 'GraduationCap',
    name: 'Education',
    description:
      'Campus lab refreshes and bulk device disposal with student-friendly awareness sessions bundled in.',
    streams: ['Computer labs', 'Projectors', 'Lab instruments'],
  },
  {
    id: 'government',
    icon: 'Building2',
    name: 'Government & PSU',
    description:
      'GeM-compatible engagements with tender documentation, e-auction support and audit-grade record keeping.',
    streams: ['Office IT assets', 'Legacy records systems', 'UPS systems'],
  },
  {
    id: 'datacentres',
    icon: 'Server',
    name: 'Data Centres',
    description:
      'Rack-level decommissioning with serialised drive tracking, on-site shredding and same-day manifest closure.',
    streams: ['Servers & racks', 'SAN/NAS arrays', 'PDUs & UPS'],
  },
  {
    id: 'retail',
    icon: 'ShoppingBag',
    name: 'Retail & E-Commerce',
    description:
      'Multi-store collection routes for POS terminals, displays and returned-device inventory.',
    streams: ['POS terminals', 'Digital signage', 'Returned devices'],
  },
  {
    id: 'hospitality',
    icon: 'Hotel',
    name: 'Hospitality',
    description:
      'Property refurbishment support covering in-room electronics, kitchen equipment and back-office IT.',
    streams: ['In-room TVs', 'Kitchen electronics', 'PMS hardware'],
  },
];
